import React from 'react'
import { Card, Flexbox } from '@/components'
import GoogleMapReact from 'google-map-react'
import formatAddress from '@/lib/formatters/address'
import envs from '@/constants/envs'
import PropTypes from 'prop-types'
import { MapContainer, Point } from './styles'
import FormAddress from './Form'

function AddressCard({ licensing, onUpdated }) {
  const center = licensing?.licensed?.location
    ? {
        lat: licensing?.licensed?.location?.coordinates[1],
        lng: licensing?.licensed?.location?.coordinates[0],
      }
    : {}

  return (
    <Flexbox.Columns>
      <Flexbox.Column className="col-12 col-sm-12 my-2">
        <Card.Base style={{ height: 'auto' }}>
          <Card.Header>
            <div className="divider text-left" data-content="Endereço" />
          </Card.Header>
          <Card.Body>
            {Boolean(licensing) && (
              <MapContainer>
                <GoogleMapReact
                  center={center}
                  defaultZoom={15}
                  options={{
                    disableDefaultUI: true,
                    zoomControlOptions: null,
                    draggable: false,
                    maxZoom: 15,
                    minZoom: 15,
                  }}
                  bootstrapURLKeys={{
                    key: envs.REACT_APP_GOOGLE_MAPS_API_KEY,
                    libraries: ['visualization'],
                  }}
                >
                  <Point lat={center.lat} lng={center.lng} />
                </GoogleMapReact>
              </MapContainer>
            )}
            <div className="pt-2 mt-2 text-bold">
              {Boolean(licensing?.licensed?.address) && (
                <>{formatAddress(licensing?.licensed?.address)}</>
              )}
            </div>
          </Card.Body>
          <Card.Footer>
            <FormAddress onUpdated={onUpdated} />
          </Card.Footer>
        </Card.Base>
      </Flexbox.Column>
    </Flexbox.Columns>
  )
}

AddressCard.propTypes = {
  licensing: PropTypes.objectOf(PropTypes.any),
  onUpdated: PropTypes.func.isRequired,
}

AddressCard.defaultProps = {
  licensing: null,
}

export default AddressCard
